<small
  class="text-black-alpha-60 mt-1 cursor-default"
  [class.block]="block">{{ ((limit > 0) && ((value === undefined) || (value === null))) ? limit : (limit - value!.length) }}
  caracteres disponíveis</small>
